<template>
  <section 
    :class="classes">

    <!-- Header -->
    <header class="n-primary-module-pane__header">
      <actions-button
        appearance="subtle"
        icon-pre="arrow-left"
        @click="$emit('close')">{{ $t('partner.back') }}</actions-button>
    </header>

    <!-- Intro -->
    <div class="n-primary-module-pane__intro">
      <!-- Icons -->
      <div class="n-primary-module-pane__icons">
        <ui-icon
          v-for="(i, j) in icons"
          :key="j"
          class="n-primary-module-pane__intro-icon n-primary-module-pane__icon1"
          :glyph="i"/>
      </div>

      <!-- Title -->
      <div class="n-primary-module-pane__name">{{ title }}</div>

      <!-- Description -->
      <div class="n-primary-module-pane__description">{{ description }}</div>
      
      <!-- Company Name -->
      <data-tag 
        v-if="isIdentity"
        class="n-primary-module-pane__customer"
        :size="$pepper.Size.S">{{ currentCustomerName }}</data-tag>
    </div>

    <!-- Impersonation -->
    <primary-impersonation 
      v-if="isIdentity" 
      />

    <!-- Links -->
    <ul 
      class="n-primary-module-pane__links">
      <li
        v-for="(e, i) in children"
        :key="i" 
        class="n-primary-module-pane__item">
        <router-link
          :to="e.href"
          @click.native.stop.prevent="onRouterClick(e)"
          class="n-primary-module-pane__link">
          
          <span class="n-primary-module-pane__group">
            <!-- Label -->
            <div class="n-primary-module-pane__label">{{ $t(e.label) }}</div>

            <!-- Restricted -->
            <div 
              v-if="e.locked"
              class="n-primary-module-pane__restricted">
              <ui-icon 
                class="n-primary-module-pane__lock"
                glyph="lock" />
            </div>

            <!-- Icon -->
            <ui-icon 
              v-else
              class="n-primary-module-pane__icon" 
              glyph="arrow-right" />
          </span>

          <span class="n-primary-module-pane__description">{{ $t(e.description) }}</span>
        </router-link>
      </li>
      
      <!-- Logout -->
      <li
        v-if="isIdentity" 
        class="n-primary-module-pane__item">
        <button 
          class="n-primary-module-pane__link -danger"
          @click="logout">

          <span class="n-primary-module-pane__group">
            <!-- Label -->
            <div class="n-primary-module-pane__label">{{ $t('partner.logout') }}</div>
            
            <!-- Icon -->
            <ui-icon 
              class="n-primary-module-pane__icon" 
              glyph="arrow-right" />
          </span>

          <span class="n-primary-module-pane__description">{{ $t('partner.logout_description') }}</span>
        </button>
      </li>

      <!-- SSM -->
      <li  
        v-if="isIdentity && ssmURL"
        class="n-primary-module-pane__item">
        <a 
          class="n-primary-module-pane__link"
          :href="ssmURL"
          target="_blank">

          <span class="n-primary-module-pane__group">
            <!-- Label -->
            <div class="n-primary-module-pane__label">{{ $t('partner.ssm_title') }}</div>
            
            <!-- Icon -->
            <ui-icon 
              class="n-primary-module-pane__icon" 
              glyph="open" />
          </span>

          <span class="n-primary-module-pane__description">{{ $t('partner.ssm_description') }}</span>
        </a>
      </li>
    </ul>

    <!-- Locked feature block -->
    <button 
      v-if="entry.locked === true"
      class="n-primary-module-pane__featurelock"
      @click="$emit('locked', entry)">
      <div class="n-primary-module-pane__lock-glyph">
        <ui-icon 
          class="n-primary-module-pane__lock-icon"
          glyph="lock" />
      </div>

      <p class="n-primary-module-pane__lock-label">{{ $t(`sayl-feature.${productName}_component_locked_title`)}}</p>
      <span 
        class="n-primary-module-pane__lock-cta"
        @click="onModalFeature">{{$t('sayl-feature.learn_more')}}</span>
    </button>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { MixinImpersonation } from '@sayl/admin-common'

import PrimaryImpersonation from './primary-impersonation'

export default {
  name: 'PrimaryNavigationModulePane',

  components: {
    PrimaryImpersonation
  },

  mixins: [
    MixinImpersonation
  ],

  props: {
    entry: {
      type: Object
    }
  },

  computed: {
    ...mapState({
      bootstrap: state => state.sayl.bootstrap
    }),

    children(){
      return this.isIdentity ? [] : this.$basil.get(this.entry, 'children', [])
    },

    classes(){
      let fqn = this.$basil.get(this.entry, 'parent.fqn')
      return {
        'n-primary-module-pane': true,
        '-is-sayl': fqn === 'sayl',
        '-is-customer': fqn === 'sayl-customer',
        '-is-resto': fqn === 'sayl-resto',
        '-is-finance': fqn === 'sayl-finance',
      }
    },

    description(){
      return this.$t(this.entry.description)
    },

    hasChildren(){
      return this.children && this.children.length > 0
    },

    icons(){
      return this.$basil.get(this.entry, 'icons', [this.$basil.get(this.entry, 'icon')])
    },
    
    isIdentity(){
      return this.$basil.get(this.entry, 'fqn') === 'sayl-identity'
    },

    productName() {
      let ret = this.$basil.get(this.entry, 'parent.fqn')

      return !this.$basil.isNil(ret) ? ret.split('-').join('_') : ''
    },

    ssmURL(){
      return this.$basil.get(this.bootstrap, 'ssm.url', null)
    },

    title(){
      return this.$t(this.entry.title) || this.$t(this.entry.label)
    },
  },

  methods: {
    onModalFeature() {
      this.$bus.$emit('feature-locked', { product: this.$basil.get(this.entry, 'parent.fqn'), feature: this.$basil.get(this.entry, 'fqn') })
    },

    onRouterClick(e) {
      this.$store.commit('sayl/setRoute', { current:e, parent: this.$basil.get(this.entry, 'parent') })
    },

    logout() {
      $dl.logout();
    },
  }
}
</script>
